import { AlertTriangle, ArrowLeft } from "lucide-react";
import { Button } from "@/shared/ui/button";

interface PropertyNotFoundStateProps {
  onBack: () => void;
}

export function PropertyNotFoundState({ onBack }: PropertyNotFoundStateProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-accent/20 flex items-center justify-center">
      <div className="bg-card/50 backdrop-blur-xl border border-border/50 rounded-2xl p-8 max-w-md text-center space-y-4">
        <div className="flex justify-center">
          <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
            <AlertTriangle className="h-8 w-8 text-primary" />
          </div>
        </div>
        <h2 className="text-xl font-semibold text-foreground">Property Not Found</h2>
        <p className="text-muted-foreground">
          The property you're looking for doesn't exist or you don't have access to it.
        </p>
        <Button onClick={onBack} className="mt-4">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Client
        </Button>
      </div>
    </div>
  );
}
